import React from 'react'
import { Modal, App} from 'antd'
import { useIncomeExpenditureDelMutation,} from '../../store/ReactWebSiteApi';
function BalanceDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useIncomeExpenditureDelMutation()  
    return (
        <>
            {
                (!props.eie_audit1_ctime && !props.eie_hx_ctime && props.eie_state==='2') && <a onClick={() => {
                    if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                                            Modal.info({
                                                title: '团队收入和团队支出请在团队台账里删除！',
                                                content: '',
                                                onOk() {},
                                              });
                                            return false
                                        }      
                    confirm({
                        title: '确定删除吗?',
                        content: props.eie_id,
                        okText: '确认',
                        okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            submitDel({
                                eie_id:props.eie_id,
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.info('删除成功！');
                                }
                                if (res.data.Status === "fail") {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        },
                        onCancel() {
                            // console.log('Cancel');
                        },
                    }); 
                }}>删除</a>
            }
            {props.eie_state==='1'&&<a onClick={() => {
                                                            confirm({
                                                                title: '确定取消删除吗?',
                                                                content: props.eie_id,
                                                                okText: '确认',
                                                                okType: 'danger',
                                                                cancelText: '取消',
                                                                onOk() {
                                                                    submitDel({
                                                                        eie_id:props.eie_id,
                                                                        eie_state:'1'
                                                                    }).then((res) => {
                                                                        console.log(res);
                                                                        if (res.data.Status === 'success') {
                                                                            message.info('取消删除成功！');
                                                                        }
                                                                        if (res.data.Status === "fail") {
                                                                            message.error('取消删除失败！'+res.data.Message)
                                                                        }
                                                                    })
                                                                },
                                                                onCancel() {
                                                                console.log('Cancel');
                                                                },
                                                            });
                                                        }}>取消删除</a>}
        </>
    )
}

export default BalanceDel